import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from '../utils/toastr.service';
import { ApiService } from '../utils/api.service';

@Injectable()
export class MediaObjectService {

  constructor(
    private apiService: ApiService,
    private toastr: ToastrService,
  ) {
  }

  save(mediaObject: File, fileName: string): Observable<any> {
    try {
      const formData = new FormData();
      formData.append('file', mediaObject, fileName);
      if (mediaObject) {
        return this.apiService.upload('media_objects', formData);
      }
    } catch (error) {
      this.toastr.showCreationErrorToast(error.message);
      return throwError(error);
    }
  }
}
